const name = 'product-price-group';

export const GET_PRODUCT_PRICE_GROUP_LIST_REQUEST = `${name}/GET_PRODUCT_PRICE_GROUP_LIST_REQUEST`;
export const GET_PRODUCT_PRICE_GROUP_LIST_SUCCESS = `${name}/GET_PRODUCT_PRICE_GROUP_LIST_SUCCESS`;
export const GET_PRODUCT_PRICE_GROUP_LIST_FAILURE = `${name}/GET_PRODUCT_PRICE_GROUP_LIST_FAILURE`;

export const UPDATE_PRODUCT_PRICE_GROUP_REQUEST = `${name}/UPDATE_PRODUCT_PRICE_GROUP_REQUEST`;
export const UPDATE_PRODUCT_PRICE_GROUP_SUCCESS = `${name}/UPDATE_PRODUCT_PRICE_GROUP_SUCCESS`;
export const UPDATE_PRODUCT_PRICE_GROUP_FAILURE = `${name}/UPDATE_PRODUCT_PRICE_GROUP_FAILURE`;

export const DELETE_PRODUCT_PRICE_GROUP_REQUEST = `${name}/DELETE_PRODUCT_PRICE_GROUP_REQUEST`;
export const DELETE_PRODUCT_PRICE_GROUP_SUCCESS = `${name}/DELETE_PRODUCT_PRICE_GROUP_SUCCESS`;
export const DELETE_PRODUCT_PRICE_GROUP_FAILURE = `${name}/DELETE_PRODUCT_PRICE_GROUP_FAILURE`;

export const GET_PRODUCT_PRICE_GROUP_DETAILS_REQUEST = `${name}GET_PRODUCT_PRICE_GROUP_DETAILS_REQUEST`;
export const GET_PRODUCT_PRICE_GROUP_DETAILS_SUCCESS = `${name}GET_PRODUCT_PRICE_GROUP_DETAILS_SUCCESS`;
export const GET_PRODUCT_PRICE_GROUP_DETAILS_FAILURE = `${name}GET_PRODUCT_PRICE_GROUP_DETAILS_FAILURE`;

export default name;